import React from 'react';
import { MENUS } from 'Common';
import { connect } from 'react-redux';
import { setSubMenuDirection } from 'actions';
import { VERTICAL, HORIZONTAL } from 'constants';
import Statistics from "./Statistics";

const SubMenu = ({ auth, subMenuDirection, step, application, setSubMenuDirection }) => {

  const handleClick = () => {
    setSubMenuDirection(subMenuDirection === VERTICAL ? HORIZONTAL : VERTICAL);
  };

  const { loggedAs, currentClient, user, preference, detached } = auth;
  const currentMenus = MENUS[loggedAs];

  if (user == null || user.id == null) {
    return null;
  }

  return (
    <nav id="subMenu" className={`sub-menu ${subMenuDirection === VERTICAL ? 'vertical' : ''}`} style={{ zIndex: 9999 }}>
      <span className="flip-menu flex-column-center" onClick={handleClick}>
        <img src={"/img/icons/menu_direction.svg"} className="icomoon icon-tt-menu" />
      </span>
      <ul className="menu">
        {(loggedAs === "ADMIN" || (user && user.type === "ADMIN")) ? (
          <Statistics subMenuDirection={subMenuDirection} />
        ) : null}
      </ul>
    </nav>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  subMenuDirection: state.params.subMenuDirection,
});

const mapDispatchToProps = dispatch => ({
  setSubMenuDirection: (direction) => dispatch(setSubMenuDirection(direction))
});

export default connect(mapStateToProps, mapDispatchToProps)(SubMenu);


// WEBPACK FOOTER //
// ./app/components/menu/SubMenu.js